import { useEffect, useState, useCallback } from "react";
import useUser from "../../../hooks/useUser";
import Loading from "../../Layout/Loading";
import { GetCRMItems } from "../../../actions/CRM";
import CRMJournal from "./CRMJournal";
import CRMLibrarian from "./CRMLibrarian";

const CRMWrapper = (props) => {
  const { user, saveUser } = useUser();
  const [items, setItems] = useState(props.items);
  const [loading, setLoading] = useState(true);
  const [isJournal, setIsJournal] = useState(true);
  // eslint-disable-next-line react-hooks/exhaustive-deps

  const processUpdate = useCallback((items) => {
    setItems(items);
    setLoading(false);
  }, []);

  useEffect(() => {
    GetCRMItems(user, saveUser, setLoading, processUpdate, (e) => {
      console.log(e);
    });
  }, [processUpdate, saveUser, user]);

  if (items === undefined || loading)
    return setTimeout(() => <Loading msg="Fetching items" />, 1500);

  const formatLibData = (items) => {
    let librarians = [];
    items.map((item) => librarians.push(item.librarians));

    const filter = librarians.filter((lib) => lib.includes(";"));
    const arr = filter.map((lib) => lib.split(";"));

    console.log(arr);
    arr.map((a) => a.map((b) => librarians.push(b)));
    const noSpace = librarians.map((lib) => lib.replace(/\s+/g, ""));
    noSpace.map((l) => l.includes(";") && noSpace.slice(l.indexOf(), 1));
    //const libs = filtered.map((l) => console.log(l));
    //libs.sort();
    //console.log(libs);
    /*     const filtered = arr.forEach((a) => {
      a.map((b) => {
        librarians.push(b);
        return librarians.sort();
      });
    });

    const libs = filtered.map((lib) => {
      return {
        name: lib,
        email: lib.email !== "" && lib.email !== undefined ? lib.email : "",
        url: lib.url !== "" && lib.url !== undefined ? lib.url : "",
      };
    });
    return libs; */
  };

  return (
    <div className="crm-box">
      <div className="crm-grid">
        {isJournal ? (
          <CRMJournal items={items["Journals"]} />
        ) : (
          <CRMLibrarian items={formatLibData(items["Journals"])} />
        )}
      </div>
    </div>
  );
};

export default CRMWrapper;
